import { GET_KLASIFIKASI_ARSIP } from 'shared/constants/ActionTypes';
import ItemCollections, { useGetItem } from 'redux/cache';
import { API } from 'shared/constants/AppEnums';
const itemCollections = new ItemCollections();
export const getKlasifikasiArsip = (searchText,useCRSFE=false) => {
  let keyUrl = API.GET_KM_PENOMORAN_ADMINTOOLS;
  let save = searchText ? false : true;
  let searchParam = useCRSFE ? '?query=' : '?query=';
  searchText ? (keyUrl += searchParam + searchText) : '';
  return useGetItem(itemCollections, keyUrl, GET_KLASIFIKASI_ARSIP, true, save,false,useCRSFE);
};
